import { Flame, Skull, AlertTriangle, PawPrint, Phone, HelpCircle, Heart, Activity } from 'lucide-react';

export const INCIDENT_CONFIG = {
  Fire: {
    icon: Flame,
    color: "#D73027", // deep red
    bgColor: "rgba(215, 48, 39, 0.2)",
    lightColor: "rgba(215, 48, 39, 0.1)",
  },
  "Cattle Killing": {
    icon: Skull,
    color: "#FC8D59", // orange-pink
    bgColor: "rgba(252, 141, 89, 0.2)",
    lightColor: "rgba(252, 141, 89, 0.1)",
  },
  "Human Killing": {
    icon: AlertTriangle,
    color: "#B2182B", // blood red
    bgColor: "rgba(178, 24, 43, 0.2)",
    lightColor: "rgba(178, 24, 43, 0.1)",
  },
  "Tiger Moment": {
    icon: PawPrint,
    color: "#4575B4", // steel blue
    bgColor: "rgba(69, 117, 180, 0.2)",
    lightColor: "rgba(69, 117, 180, 0.1)",
  },
  "Adoc. Call": {
    icon: Phone,
    color: "#91BFDB", // sky blue
    bgColor: "rgba(145, 191, 219, 0.2)",
    lightColor: "rgba(145, 191, 219, 0.1)",
  },
  "Animal Accident": {
    icon: Skull,
    color: "#E08214", // earthy orange
    bgColor: "rgba(224, 130, 20, 0.2)",
    lightColor: "rgba(224, 130, 20, 0.1)",
  },

  "Human Killing": {
    icon: Heart,
    color: "#800026", // dark crimson
    bgColor: "rgba(128, 0, 38, 0.2)",
    lightColor: "rgba(128, 0, 38, 0.1)",
  },
  Other: {
    icon: HelpCircle,
    color: "#999999", // neutral gray
    bgColor: "rgba(153, 153, 153, 0.2)",
    lightColor: "rgba(153, 153, 153, 0.1)",
  },
};

export const DEATH_INJURED_CONFIG = {
  "Death": {
    icon: Flame,
    color: "#FF6B6B", // deep red
    bgColor: "rgba(215, 48, 39, 0.2)",
    lightColor: "rgba(215, 48, 39, 0.1)",
  },
  "Injury": {
    icon: Skull,
    color: "#4ECDC4", // orange-pink
    bgColor: "rgba(252, 141, 89, 0.2)",
    lightColor: "rgba(252, 141, 89, 0.1)",
  },

};

export const formatHeader = (str) => {
  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};


export  const GROUPING_OPTIONS = [
  {
    id: "typeofIncident",
    label: "Death/Injury Details",
    key: "typeofIncident",
    nameKey: "typeofIncident",
    colors: ["#FF6B6B", "#4ECDC4", "#FFD166"],
  },
  {
    id: "gender",
    label: "Gender Details",
    key: "gender",
    nameKey: "gender",
    colors: ["#FF6B6B", "#4ECDC4", "#FFD166"],
  },

  {
    id: "locationType",
    label: "Location Type",
    key: "locationType",
    nameKey: "locationType",
    colors: ["#6A0572", "#1A936F", "#3D5A80"],
  },
  {
    id: "killedByWildAnimal",
    label: " Killed By Wild Animal Incidents",
    key: "killedByWildAnimal",
    nameKey: "killedByWildAnimal",
    colors: ["#6A0572", "#1A936F", "#3D5A80", "#F86624"],
  },
  {
    id: "wildlife",
    label: "Killed By Wild Animal Incidents",
    key: "wildlife",
    nameKey: "wildlife",
    colors: ["#6A0572", "#1A936F", "#3D5A80", "#F86624"],
  },
  {
    id: "typeofIncidentReason",
    label: "Incident Reasons",
    key: "typeofIncidentReason",
    nameKey: "typeofIncidentReason",
    colors: ["#6A0572", "#1A936F", "#3D5A80", "#F86624","#FF6B6B", "#4ECDC4", "#FFD166"],
  },
   {
    id: "animalType",
    label: "प्रवेश करणारा प्राणी (Animal Type)",
    key: "animalType",
    nameKey: "animalType",
    colors: ["#6A0572", "#1A936F", "#3D5A80", "#F86624","#FF6B6B", "#4ECDC4", "#FFD166"],
  },
  {
    id: "age",
    label: "Age Group Wise",
    key: "age",
    nameKey: "age",
    colors: ["#6A0572", "#1A936F", "#3D5A80", "#F86624","#FF6B6B", "#4ECDC4", "#FFD166"],
  },
  
];
